import { render, staticRenderFns } from "./DropdownMenuElement.vue?vue&type=template&id=d4225c4c&"
import script from "./DropdownMenuElement.vue?vue&type=script&lang=js&"
export * from "./DropdownMenuElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports